import { useEffect, useRef, useState } from "react";

// Animate a number from 0 to target when the element scrolls into view.
export function CountUp({ end, duration = 1800, suffix = "", className = "" }) {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!ref.current || started) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          const startTime = performance.now();
          const numericEnd = parseFloat(String(end).replace(/[^0-9.]/g, "")) || 0;
          const tick = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            // ease-out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            setValue(numericEnd * eased);
            if (progress < 1) requestAnimationFrame(tick);
            else setValue(numericEnd);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [end, duration, started]);

  const isFloat = String(end).includes(".");
  const display = isFloat ? value.toFixed(1) : Math.round(value);
  return <span ref={ref} className={className}>{display}{suffix}</span>;
}
